import { API_URL, GETAPI } from "./config";

export const GET_FAQ_LIST = async (type) => {
  let query = "";
  query += "?type=" + type;

  const res = await GETAPI(API_URL.getFaqList, query);
  return res;
};
